import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'VideoChat',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'locationId',
        'deviceSerial',
        'modelNumber',
        'modelName',
        'nickName',
        'display',
        'isFavorite',
        'status',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          locationId: 'ロケーションID',
          deviceSerial: '端末製造番号',
          modelNumber: '品番',
          modelName: '機種名',
          display: '電話帳表示',
          nickName: 'ニックネーム',
          isFavorite: 'お気に入り',
          status: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          locationId: 'wp-10',
          deviceSerial: '',
          modelNumber: '',
          modelName: '',
          nickName: '',
          status: '',
          isFavorite: '',
          display: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'locationId',
          'deviceSerial',
          'modelNumber',
          'modelName',
          'display',
          'nickName',
          'isFavorite',
          'status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('ささえiでんわユーザー'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 検索
      searchService: '',
      searchLocationId: null,
      searchDeviceSerial: null,
      searchNickname: null,
      // searchAttribute: '',
      searchDeviceType: '',
      searchDeviceStatus: '',
      searchDisplayStatus: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      loadedSearchModel: false,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts('ささえiでんわユーザー'))

    this.init()
  },
  beforeDestroy() {
    this.resetState()
  },
  computed: {
    ...mapState({
      categoryName: state => state.videoChat.categoryName,
      // model
      videoChatModel: state => state.videoChat.videoChatModel,
      serviceModel: state => state.videoChat.serviceModel,
      deviceModel: state => state.videoChat.deviceModel,
      attributeModel: state => state.videoChat.attributeModel,
      serviceInfoModel: state => state.videoChat.serviceInfoModel,
      // modal
      updatedList: state => state.videoChatModifyModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    serviceList () {
      return this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .map(item => {
        return {
          value: item.serviceUuid,
          label: item.serviceName
        }
      })
    },
    attributeList () {
      // return Constants.VideoChat.Attribute
      return this.attributeModel.map(item => {
        return {
          value: item.attributeTypeUUID,
          label: item.attributeTypeName
        }
      })
    },
    deviceList () {
      return this.deviceModel.map(item => {
        return {
          value: item.deviceTypeUuid,
          label: item.modelName
        }
      })
    },
    deviceStatusList () {
      return Constants.VideoChat.Status
    },
    displayStatusList () {
      return Constants.VideoChat.Display
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // enable
    // disableAttribute() {
    //   return !this.loadedSearchModel
    // },
    disableDevice() {
      return !this.loadedSearchModel
    },

    communityUUid() {
      return serviceUuid => this.serviceModel.filter(item => item.serviceUuid === serviceUuid)[0].communityUuid || null
    }
  },
  watch: {
    searchService (to) {
      // this.searchAttribute = ''
      this.searchDeviceType = ''

      if (to) {
        this.loadedSearchModel = false
        const serviceAttributeParams = {
          serviceUuid: to
        }
        const deviceParams = {
          filters: {
            communityUuid: this.isAdmin
              ? [this.communityUUid(to)]
              : [this.serviceInfoModel.communityUuid]
          }
        }

        // 属性選択、デバイス選択の選択地を読み込み
        this.loadSearchModel({
          serviceAttributeParams: serviceAttributeParams,
          deviceParams: deviceParams
        })
          .then(res => {
            this.loadedSearchModel = true
          })
          .catch(error => {
            this.showError(error || null)
          })

        // サービス変更時にチャットリストを読み込み
        this.search()
      } else {
        this.loadedSearchModel = false
      }
    },
    updatedList: function (to) {
      if (!to) return
      // モーダルで対象配信タイプの変更がされたら一覧を更新
      this.search()
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'videoChat/loadModel',
      loadSearchModel: 'videoChat/loadSearchModel',
      loadVideoChatList: 'videoChat/loadVideoChatList',
      resetState: 'videoChat/resetState',
      showVideoChatModifyModal: 'videoChatModifyModal/show'
    }),

    init () {
      this.loading = true

      // データ検索パラメータ
      let serviceParams = {}
      let videoChatParams = { filters: {} }

      if (this.isOperator) {
        videoChatParams.filters.serviceUuid = this.userServiceUuid
        serviceParams.serviceUuid = this.userServiceUuid
      }

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams,
        videoChatParams: videoChatParams,
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.videoChatModel)

          if (this.isOperator) {
            this.searchService = this.userServiceUuid
          }
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'display':
          return Utility.getConstantsLabel(['VideoChat', 'Display'], value)
        case 'status':
          return Utility.getConstantsLabel(['VideoChat', 'Status'], value)
        case 'isFavorite':
          return Utility.getConstantsLabel(['VideoChat', 'Favorite'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchService = ''
      this.searchLocationId = null
      this.searchDeviceSerial = null
      this.searchNickname = null
      // this.searchAttribute = ''
      this.searchDeviceType = ''
      this.searchDeviceStatus = ''
      this.searchDisplayStatus = ''

      this.init()
    },
    search () {
      this.loading = true

      // データ検索パラメータ
      let videoChatParams = { filters: {} }
      if (this.searchService)
        videoChatParams.filters.serviceUuid = this.searchService
      if (this.searchLocationId)
        videoChatParams.filters.locationId = this.searchLocationId
      if (this.searchDeviceSerial)
        videoChatParams.filters.deviceSerial = this.searchDeviceSerial
      if (this.searchNickname)
        videoChatParams.filters.nickName = this.searchNickname
      // if (this.searchAttribute)
        // videoChatParams.filters.attributeUuid = this.searchAttribute
      if (this.searchDeviceType)
        videoChatParams.filters.deviceTypeUuid = this.searchDeviceType
      if (this.searchDeviceStatus !== '')
        videoChatParams.filters.deviceStatus = this.searchDeviceStatus
      if (this.searchDisplayStatus !== '')
        videoChatParams.filters.displayStatus = this.searchDisplayStatus

      // データ読出し
      this.loadVideoChatList({
        videoChatParams: videoChatParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.videoChatModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    // 電話帳表示・非表示設定
    toggleDisplay () {
      //TODO
    },
    detailItem(props) {
      this.showVideoChatModifyModal({
        data: props.row
      })
    },

    gotoVideoChatApp() {
      const url = process.env.VUE_APP_VIDEOCHAT;
      window.open(url);
    }
  }
}